module.exports = __webpack_public_path__ + "img/icon_wuxingbi_module1.bac877bc.png";